module.exports = __webpack_public_path__ + "static/img/pic_state_green.a04f3e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/login/pic_state_green.png
// module id = ghlf
// module chunks = 83